import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { gutter } from '../../styles/mixins';

const Host = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 34px;
  margin-bottom: 20px;
`;

const Left = styled.div``;

const Right = styled.div<{ hideDesktop: boolean }>`
  display: flex;
  > * {
    margin: 0 ${gutter(1)};
  }
  @media ${device.desktop} {
    ${({ hideDesktop }) => hideDesktop && 'display: none;'}
  }
`;

interface LotNavProps {
  left: React.ReactNode;
  right: React.ReactNode;
  hideDesktop?: boolean;
}

export const LotNav = ({ left, right, hideDesktop }: LotNavProps) => {
  return (
    <Host>
      <Left>{left}</Left>
      <Right hideDesktop={!!hideDesktop}>{right}</Right>
    </Host>
  );
};
